import { difference, forEach, reduce, values } from 'lodash';
import { isOfType } from '../../../../ts-utils';
import { Fieldset, } from '../../../../controller/services/comments-service';
export function initLiveCommentsFetcher({ emitSuccessTo: emitSuccess, emitNotFoundTo: emitNotFound, emitFailureTo: emitFailure, fetchFn, }) {
    const pendingIds = {};
    return ({ resourceId, unresolvedIdsByCtx, withVotes, }) => {
        const idsToFetch = reduce(unresolvedIdsByCtx, (acc, { commentIds: ids, ctxFields }, ctxKey) => {
            const notPendingIds = difference(ids, pendingIds[ctxKey]);
            if (notPendingIds.length > 0) {
                acc[ctxKey] = {
                    commentIds: notPendingIds,
                    ctxFields,
                };
            }
            return acc;
        }, {});
        fetch(idsToFetch, true);
        function fetch(ids, retry) {
            forEach(ids, async ({ commentIds, ctxFields }, ctxKey) => {
                pendingIds[ctxKey] = [...commentIds, ...(pendingIds[ctxKey] || [])];
                const result = await fetchFn({ ctxFields, commentIds, withVotes, resourceId });
                if (result.type === 'SUCCESS') {
                    const response = result.response;
                    const foundIds = (response.comments || []).map((c) => c.commentId);
                    const notFoundIds = difference(commentIds, foundIds);
                    if (foundIds.length) {
                        emitSuccess({
                            comments: response.comments,
                            members: response.members || [],
                            memberBadges: response.memberBadges || {},
                            memberRoles: response.memberRoles || {},
                            notFoundIds,
                            votes: response.votes,
                        });
                        pendingIds[ctxKey] = difference(pendingIds[ctxKey], foundIds);
                    }
                    if (notFoundIds.length) {
                        // TODO: retry once
                        if (!retry) {
                            emitNotFound({
                                commentIds: notFoundIds,
                            });
                        }
                        else {
                            setTimeout(() => fetch({ [ctxKey]: { commentIds: notFoundIds, ctxFields } }, false), 3000);
                        }
                    }
                }
                else {
                    pendingIds[ctxKey] = difference(pendingIds[ctxKey], commentIds);
                    emitFailure({
                        commentIds,
                        error: result.error,
                    });
                }
            });
        }
    };
}
export function makeFetchFn(commentsService, appId) {
    return async ({ ctxFields, commentIds, withVotes, resourceId }) => {
        return commentsService.getBulkComments({
            appId,
            resourceId,
            contextId: ctxFields.contextId,
            contextType: ctxFields.contextType,
            fieldsets: [
                Fieldset.MEMBERS,
                Fieldset.MEMBER_BADGES,
                Fieldset.MEMBER_ROLES,
                Fieldset.CONTEXT_PERMISSIONS,
                ...(withVotes ? [Fieldset.VOTES] : []),
            ],
            commentIds,
        });
    };
}
export function getUnresovedIdsByCtx(state, appDefId) {
    return reduce(state.comments, (acc, resourceState) => {
        if (resourceState?.type !== 'READY') {
            return acc;
        }
        const unresolvedIds = values(resourceState.commentsById)
            .filter(isOfType(['COMMENT_LIVE_PENDING', 'REPLY_LIVE_PENDING']))
            .map((c) => c.commentId);
        if (unresolvedIds.length > 0) {
            const key = generateCtxBasedKey(appDefId, resourceState.configs.ctxFields);
            acc[key] = {
                ctxFields: resourceState.configs.ctxFields,
                commentIds: [...unresolvedIds, ...(acc[key]?.commentIds || [])],
            };
        }
        return acc;
    }, {});
}
function generateCtxBasedKey(appDefId, ctxFields) {
    return `${appDefId || ''}${ctxFields.contextId || ''}${ctxFields.contextType || ''}`;
}
//# sourceMappingURL=live-comments-fetcher.js.map